










































































































import { Component, Mixins } from 'vue-mixin-decorator';
import { SlotMixin } from '@/mixins/SlotMixin';
import { GET_INVOICES, GET_META, GET_STATUS, INVOICES_REQUEST } from '@/store/models/work/enterprise/invoices/outgoing';
import { Getter, namespace } from 'vuex-class';
import { Invoice } from '@/types/work/invoice';
import InvoiceItem from '@/components/work/invoices/item.vue';
import InvoiceReport from '@/components/work/invoices/report.vue';
import { NAMESPACE } from '@/store/models/work/enterprise/customers';
import { NAMESPACE as P_NAMESPACE } from '@/store/models/work/enterprise/positions';
import { NAMESPACE as CR_NAMESPACE } from '@/store/models/work/enterprise/cashRegisters';
import Pagination from '@/components/Pagination.vue';
import { PageMeta } from '@/types/pagination';
import { Watch } from 'vue-property-decorator';
import Dialog from '@/components/Dialog.vue';
import { GET_ITEMS, ITEMS_REQUEST } from '@/store';
import { PositionModel } from '@/store/types/work/Positions';
import SelectCustomer from '@/components/work/customers/SelectCustomer.vue';

const customersStore = namespace(NAMESPACE);
const positionsStore = namespace(P_NAMESPACE);
const cRStore = namespace(CR_NAMESPACE);
@Component({
  components: { SelectCustomer, Dialog, Pagination, InvoiceItem, InvoiceReport }
})
export default class OutgoingIndex extends Mixins<SlotMixin>(SlotMixin) {
  @Getter(GET_INVOICES) invoices!: Invoice[];
  @Getter(GET_STATUS) status!:boolean|null;

  // cash registers for add balance
  @cRStore.Action(ITEMS_REQUEST) cRRequest: any;

  @positionsStore.Getter(GET_ITEMS) positions!:PositionModel[];
  @positionsStore.Action(ITEMS_REQUEST) positionsRequest:any;
  @Getter(GET_META) meta!:PageMeta;

  @Watch('$route.query')
  public onQueryChange () {
    this.setFilters();
  }

  productsStatuses:any[] = [
    { t: 'Відправлено', v: 1 },
    { t: 'Віхдилено', v: 0 },
    { t: 'Очікується', v: 'null' }
  ]

  showDialog = false;

  public fab = false;

  public filters = {
    provider_id: null,
    user_id: null,
    products_received: null,
    debt_obtained: 0,
    search: ''
  };

  loading () {
    return this.status === null;
  }

  setFilters () {
    this.$store.dispatch(INVOICES_REQUEST, {
      filters: { ...this.filters },
      sort: [
        { column: 'created_at', type: 'desc' }
      ],
      per_page: 20,
      ...this.$route.query
    });
  }

  created () {
    this.$store.dispatch(INVOICES_REQUEST, { sort: [
      { column: 'created_at', type: 'desc' }
    ],
    per_page: 20,
    ...this.$route.query
    });
    this.positionsRequest();
    this.cRRequest();
    this.$gtag.event('page_view', {});
  }
}
